import { isAbleToSeeUIElement } from './roles/client-roles';
import { TierError, PermissionError } from './custom-errors';
import { PageConfigItem, pagesConfig } from '../shared/pages-config';
import { Messages } from './message-constants';
import { useUserSettings } from './use-user-settings';

function validateUserAccess(
  usersTier: {
    rank: number;
    value: string;
    displayValue: string;
  },
  pageConfigItem: PageConfigItem,
  comparisonRoles: string[],
  userRoles: string[],
  directoryRoles: string[]
) {
  if (usersTier.rank < pageConfigItem.minimumTier) {
    throw new TierError(
      Messages.Errors.Tier.Viewing(pageConfigItem.minimumTierDisplayValue)
    );
  }

  // If they don't have the User Management permission, they can't view any user details
  if (
    pageConfigItem.isUserDetails &&
    !isAbleToSeeUIElement(userRoles, pagesConfig.users.requiredPermission)
  ) {
    throw new PermissionError(
      Messages.Errors.Permission.Viewing(
        pagesConfig.users.requiredPermissionDisplayValue
      )
    );
  }

  // If  they don't have Groups permission, they can't view any group details
  if (
    pageConfigItem.isGroupDetails &&
    !isAbleToSeeUIElement(
      directoryRoles,
      pagesConfig.groups.requiredPermission
    ) &&
    !pageConfigItem.isUserPortal
  ) {
    throw new PermissionError(
      Messages.Errors.Permission.Viewing(
        pagesConfig.groups.requiredPermissionDisplayValue
      )
    );
  }

  if (
    !isAbleToSeeUIElement(comparisonRoles, pageConfigItem.requiredPermission) &&
    pageConfigItem.requiredPermission !== '*'
  ) {
    throw new PermissionError(
      Messages.Errors.Permission.Viewing(
        pageConfigItem.requiredPermissionDisplayValue
      )
    );
  }
}

export function useValidateUserAccess(
  pageConfigItem: PageConfigItem,
  comparisonRoles: string[]
) {
  const { usersTier, userRoles, directoryRoles } = useUserSettings();

  validateUserAccess(
    usersTier,
    pageConfigItem,
    comparisonRoles,
    userRoles,
    directoryRoles
  );
}
